import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  getPracticeLocationTypes,
  addPracticeLocation,
  updatePracticeLocations,
  getLocationSuggestions,
} from '../../actions/userActions/practiceLocationAction'
import { getCities } from '../../actions/userActions/cityAction'
import { Redirect } from 'react-router-dom'
import { useLocation, useHistory } from 'react-router-dom'
import { CircularProgress, IconButton } from '@mui/material'
import HrComponent from '../reuse_components/HrComponent'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'
import SingleSelect from '../designSystem/SingleSelect'
import BodyLargeMedium from '../designSystem/BodyLargeMedium'
import practicelocationicon from "../../assets/images/practicelocationicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import TextField from '../designSystem/TextField'
import { validateFields } from '../../utils/Validations'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import { Check, X } from 'lucide-react'
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import AddNewDrawer from '../addNew/AddNewDrawer'
import AddNewForm from '../addNew/AddNewForm'
import cityicon from "../../assets/images/cityIcon (2).svg";
import { t } from '../../locales/translate'
function AddPracticeLocations({ onClose, editData, onSave }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const initialValues = {
    name: '',
    type: '',
    address: '',
    city: '',
  }
  const [loading, setLoading] = useState(true); // Loading state
  const [saveLoading, setSaveLoading] = useState(false);
  const [formValues, setFormValues] = useState(initialValues)
  const [formErrors, setFormErrors] = useState({})
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '1',
  })
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  }
  const allCities = useSelector((state) => state.cities_reducer.cities)
  const locationSuggestions = useSelector(state => state.practiceLocations_reducer.locationSuggestions);
  const practiceLocationType = useSelector(
    (state) => state.practiceLocations_reducer.practiceLocationTypes,
  )
  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      await dispatch(getCities(cityBody));
      await dispatch(getPracticeLocationTypes(-1));

      if (editData) {
        setFormValues(editData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();

}, [editData]);

  const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, 'practicelocation');
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  
  setSaveLoading(true);
  try {
    if (editData) {
      await dispatch(updatePracticeLocations(formValues));
    } else {
      await dispatch(addPracticeLocation(formValues));
    }
    setSaveLoading(false);
    await onSave(formValues);
  } catch (error) {
    console.error("Error saving practice location:", error);
    setSaveLoading(false);
  }
};

   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }


  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const handleGoBack = () => {
    history.goBack();
  };
  const getOptions = (type) => {
   if (type === "allCities") {
      if (
        allCities !== "isLoading" &&
        allCities.length !== 0 &&
        allCities?.result.length !== 0
      ) {
        return allCities.result
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((city) => ({
            value: city.id,
            label: city.name
          }));
      }
      return [];
  }

    if (type === "practiceLocationType") {
      if (
        practiceLocationType !== "isLoading" &&
        practiceLocationType.length !== 0 &&
        practiceLocationType.result &&
        practiceLocationType.result.length !== 0
      ) {
        return practiceLocationType.result
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((locationType) => ({
            value: locationType.id,
            label: locationType.name
          }));
      }
      return [];
    }

    return [];
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value
    })
  }
  const handleTypeChange = (event) => {
    setFormValues({
      ...formValues,
      type: event.value
    })
  }
  const handleLocationInputChange = (locationName) => {
    if (locationName.length >= 3) {
      dispatch(getLocationSuggestions(locationName));
    }
  };
  const renderLocationSuggestions = (locations) => {
    return locations.map((location, index) => (
      <div key={index} className="suggestion-item">
        <BodySmallMedium text={location.name} />
        {(location.address || location.typeName) && (
          <BodyExtraSmallMedium
            text={
              location.address && location.typeName
                ? `${location.address} • ${location.typeName}`
                : location.address || location.typeName
            }
          />
        )}
      </div>
    ));
  };
  return (
    <>
      <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
        <LoadingOverlay isVisible={loading || saveLoading} />
        <div className={(loading || saveLoading) ? 'blur' : ''}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={practicelocationicon} alt="practicelocationicon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Practice Location" :  `${t("addPracticeLocation")}`}
                </h2>
                <p className="modaldescription">
                  {t("addPracticeLocationTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <div className="dynamicmodal-form-group">
                <TextField
                  label={`${t("name")} *`}
                  type='text'
                  name='name'
                  value={formValues.name}
                  onChange={handletextChange}
                  placeholder={t("name")}
                  error={formErrors.name}
                  enableSuggestions={true}
                  suggestions={locationSuggestions || []}
                  minCharsForSuggestions={3}
                  onSuggestionInputChange={handleLocationInputChange}
                  renderSuggestions={renderLocationSuggestions}
                />
              </div>
              <SingleSelect
                label={`${t("locationType")} *`}
                isSearchable
                // type="radio"
                secondaryLabel
                // iconStart={<Search width={16} height={16} />}
                error={formErrors.type}
                iconEnd
                onChange={handleTypeChange}
                value={formValues.type}
                placeholder={t("locationType")}
                options={(practiceLocationType &&
                  practiceLocationType !== "isLoading" &&
                  practiceLocationType.length !== 0 && practiceLocationType.result &&
                  practiceLocationType.result.length !== 0)
                  && getOptions("practiceLocationType")}
              />
              <SingleSelect
  label={`${t("city")} *`}
  isSearchable
  secondaryLabel
  error={formErrors.city}
  iconEnd
  onChange={handleCityChange}
  value={formValues.city}
  placeholder={t("city")}
  options={(allCities &&
    allCities !== "isLoading" &&
    allCities.length !== 0 && allCities?.result &&
    allCities.result?.length !== 0)
    && getOptions("allCities")}
  isLoading={!allCities || allCities === "isLoading"}
  configKey={"city"}
  onAddNewClick={() => handleAddNew("city")}
 />
              <div className="dynamicmodal-form-group">

                <TextField
                  name='address'
                  label={`${t("address")} *`}
                  type='text'
                  value={formValues.address}
                  onChange={handletextChange}
                  placeholder={t("address")}
                  error={formErrors.address}
                />
              </div>


            </div>
            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
          </div>
        </div>
      </div>
        <AddNewDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
  subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
  icon={drawerItem  === "city" ? <img src={cityicon} alt={drawerItem } /> : null}
  loading={drawerLoading}
>
          {drawerItem  && (
           <AddNewForm
  itemName={drawerItem}
  onClose={() => setDrawerOpen(false)}
  onLoadingChange={setDrawerLoading}
  onSave={(newCity) => {
    if (drawerItem === "city") {
      dispatch(getCities(cityBody)).then(() => {
        setFormValues((prev) => ({
          ...prev,
          city: newCity.id
        }));
      });
    }
  }}
/>
          )}
      </AddNewDrawer>
    </>
  )
}

export default AddPracticeLocations
